module.exports = require("puppeteer-extra");